import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { 
  getActivityFeedList,
  getActivityFeedDetail,
  getActivityMarketingList,
  getActivityMarketingDetail
} from "./api"

export const useGetActivityFeedList = ({ params, enabled = true }) => {
  return useQuery({
    queryKey: ['get-activity-feed-list', params],
    queryFn: () => getActivityFeedList(params),
    enabled: enabled
  })
}

export const useGetActivityFeedListInfinite = ({ params, enabled = true }) => {
  return useInfiniteQuery({
    queryKey: ['get-activity-feed-list-infinite', params],
    queryFn: ({ pageParam = 1 }) => getActivityFeedList({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) => {
      console.log(lastPage)
      return !!lastPage?.data?.data?.length ? +lastPage.headers["x-page"] + 1 : undefined
    },
    enabled: enabled
  })
}

export const useGetActivityFeedDetail = ({ id, enabled = true }) => {
  return useQuery({
    queryKey: ['get-activity-feed-detail', id],
    queryFn: () => getActivityFeedDetail(id),
    enabled: enabled && !!id
  })
}

export const useGetActivityMarketingList = ({ params, enabled = true }) => {
  return useQuery({
    queryKey: ['get-activity-marketing-list', params],
    queryFn: () => getActivityMarketingList(params),
    enabled: enabled
  })
}

export const useGetActivityMarketingListInfinite = ({ params, enabled = true }) => {
  return useInfiniteQuery({
    queryKey: ['get-activity-marketing-list-infinite', params],
    queryFn: ({ pageParam = 1 }) => getActivityMarketingList({ ...params, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = allPages.length;
      const totalPages = Math.ceil((lastPage?.data?.total || 0) / (params?._limit || 10));
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    enabled: enabled
  })
}

export const useGetActivityMarketingDetail = ({ id, params, enabled = true }) => {
  return useQuery({
    queryKey: ['get-activity-marketing-detail', id, params],
    queryFn: () => getActivityMarketingDetail(id, params),
    enabled: enabled && !!id
  })
}

export const useGetActivityMarketingDetailInfinite = ({ id, params, enabled = true }) => {
  return useInfiniteQuery({
    queryKey: ['get-activity-marketing-detail-infinite', id, params],
    queryFn: ({ pageParam = 1 }) => getActivityMarketingDetail(id, { ...params, page: pageParam }),
    getNextPageParam: (lastPage) => {
      const currentPage = parseInt(lastPage.headers["x-page"]);
      const perPage = parseInt(lastPage.headers["x-per-page"]);
      const total = parseInt(lastPage.headers["x-total"]);
      const totalPages = Math.ceil(total / perPage);
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    enabled: enabled && !!id
  })
}
